window.startSpinner = (element, label = null) ->
  if label
    $(".label", element).text(label)
  $(".spinner-border", element).show()

window.stopSpinner = (element, label = null) ->
  if label
    $(".label", element).text(label)
  $(".spinner-border", element).hide()
